import { TOGGLE_QUICK_PANEL } from '../constants';

export function toggleQuickPanel() {
  return {
    type: TOGGLE_QUICK_PANEL,
  };
}
